import * as React from 'react';
import { ProgressBar } from 'react-bootstrap';
import Loader from 'react-loader';

interface ProgressBarOverlayProps {
    active: boolean;
    filled: number;
    extraText: string;
    fake: boolean;
}

const options = {
    top: '10%',
    position: 'relative'
};

const ProgressBarOverlay = (props: ProgressBarOverlayProps) => {
    if (props.filled == 0) {
        return (
            <div className="overlay-progress-bar">
                <div className="modal-progress-bar">
                    <Loader loaded={false} options={options} className="spinner"></Loader>
                    <div className="spinner-label">Please wait. Preparing download... </div>
                </div>
            </div>
        );
    }

    return (
        <div className="overlay-progress-bar">
            <div className="modal-progress-bar">
                <ProgressBar
                    className="download-progress"
                    active={props.fake ? props.active : false}
                    now={props.filled}
                    label={props.fake ? `${props.filled}%` : `Downloading...`}
                    max={100}
                    bsStyle="success"
                />
                <span>{(props.fake ? `${props.filled}% ` : ``) + `(${props.extraText})`}</span>
            </div>
        </div>
    );
};

export default ProgressBarOverlay;
